<template>
    <!-- 司机-司机任务-统计-查看订单 -->
    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="90%" :before-close="closeDialog">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="name" label="司机姓名" min-width="140"> </el-table-column>

            <el-table-column prop="phone" label="司机手机号" min-width="100"> </el-table-column>

            <el-table-column prop="billno" label="订单号" min-width="100"> </el-table-column>

            <el-table-column prop="start_time_stamp" label="订单开始时间" min-width="160"> </el-table-column>
            <el-table-column prop="end_time_stamp" label="订单完成时间" min-width="160"> </el-table-column>
            <el-table-column prop="order_source" label="订单来源" min-width="200"> </el-table-column>
            <el-table-column prop="pay_channel" label="支付方式" min-width="200"> </el-table-column>
            <el-table-column prop="order_mode_code" label="订单模式" min-width="200"> </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <el-pagination
                v-if="result_data.count"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
        <div style="width: 200px; margin: 0 auto">
            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
let _this;

export default {
    props: {
        isShow: Boolean,
        data: '',
        parent: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            if (_this.parent) {
                // 如果点击表格的子节点进入查看页面
                _this.search_data.loop_task_code = _this.data.loop_task_code;
                _this.search_data.driver_code = _this.parent.driver_code;
                _this.search_data.driver_task_statistic_code = _this.parent.driver_task_statistic_code;
                _this.search_data.driver_task_code = _this.parent.driver_task_code;
            } else {
                // 如果点击表格的父节点进入查看页面
                _this.search_data.driver_code = _this.data.driver_code;
                _this.search_data.driver_task_statistic_code = _this.data.driver_task_statistic_code;
                _this.search_data.driver_task_code = _this.data.driver_task_code;
            }

            _this.searchDriverTaskDetailLists();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,
            tableData: [],
            result_data: {},
            search_data: {
                page: 1,
                limit: 10,
                driver_code: '',
                loop_task_code: '',
                driver_task_code: '',
                driver_task_statistic_code: ''
            }
        };
    },
    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.tableData = [];
            _this.result_data = {};
            _this.search_data = {
                page: 1,
                limit: 10,
                driver_code: '',
                loop_task_code: '',
                driver_task_code: '',
                driver_task_statistic_code: ''
            };
        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.driverTaskDetailLists();
        },

        searchDriverTaskDetailLists() {
            _this.search_data.page = 1;
            _this.driverTaskDetailLists();
        },
        driverTaskDetailLists() {
            _this.$post('/task_new/driverTaskNewStatisticOrderLists', _this.search_data).then((res) => {
                _this.result_data = res.data;
                _this.tableData = res.data.result;
            });
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
